import { request } from "./http";

export interface Rts27Row {
  period_start: string;
  period_end: string;
  venue: string;
  instrument_class: string;
  fill_count: number;
  qty_total: string;
  notional_total: string;
  avg_slippage_bps: string;
  median_slippage_bps: string;
  p99_slippage_bps: string;
  avg_latency_ms: number;
  rejected_pct: number;
}

export interface Rts28Row {
  period_start: string;
  period_end: string;
  instrument_class: string;
  rank: number;
  venue: string;
  pct_of_volume: number;
  pct_of_orders: number;
}

export interface ExecutionQualitySnapshot {
  id: string;
  timestamp: string;
  venue: string;
  instrument_class: string;
  side: "BUY" | "SELL";
  quantity: string;
  fill_price: string;
  nbbo_bid: string | null;
  nbbo_ask: string | null;
  slippage_bps: string | null;
  price_improvement_bps: string | null;
  latency_ms: number | null;
  routing_decision: "A_BOOK" | "B_BOOK" | "MIXED" | null;
}

export const bestEx = {
  rts27: (period: string) =>
    request<Rts27Row[]>(
      `/api/v1/admin/best-execution/rts27?period=${encodeURIComponent(period)}`,
    ),
  rts28: (period: string) =>
    request<Rts28Row[]>(
      `/api/v1/admin/best-execution/rts28?period=${encodeURIComponent(period)}`,
    ),
  rts27CsvUrl: (period: string) =>
    `/api/v1/admin/best-execution/rts27?period=${encodeURIComponent(period)}&fmt=csv`,
  rts28CsvUrl: (period: string) =>
    `/api/v1/admin/best-execution/rts28?period=${encodeURIComponent(period)}&fmt=csv`,
  snapshots: (params: { from?: string; to?: string; venue?: string; instrument_class?: string; limit?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.from) qs.set("from", params.from);
    if (params.to) qs.set("to", params.to);
    if (params.venue) qs.set("venue", params.venue);
    if (params.instrument_class) qs.set("instrument_class", params.instrument_class);
    if (params.limit) qs.set("limit", String(params.limit));
    return request<ExecutionQualitySnapshot[]>(
      `/api/v1/admin/best-execution/snapshots${qs.toString() ? "?" + qs : ""}`,
    );
  },
};
